import { ClientRiskDataAPI } from "../API/client_risk_data"


export const ClientRiskDataController = {

    async createData(clientId, month, year) {

        const response = await ClientRiskDataAPI.createData(clientId, month, year);
        if (response.success) {

            console.log('createData risk: ', response);
            const responseToReturn = {
                able: true,

            }

            if (response.body?.rows?.[0]) {
                const responseData = response.body.rows[0];
                const {
                    articles_data,
                    benchmarks_data,
                    market_data,
                } = responseData;

                responseToReturn.data = {
                    articles_data: articles_data,
                    benchmarks_data: benchmarks_data,
                    market_data: market_data,
                }
            }

            return responseToReturn;

        } else {
            return null;
        }

    },

}